var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            height: "100%",
            border: true,
            "header-cell-style": { color: "#333333", background: "#EFF6FF" },
            "tooltip-effect": "dark",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              fixed: "left",
              width: "55",
              selectable: _vm.selectAble,
            },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "80",
              align: "center",
              label: "序号",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplier_name",
              align: "center",
              label: "供应商名称",
              "min-width": "200",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.supplier
                      ? _c("span", [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.supplier.title || "-")),
                          ]),
                          _vm._v(
                            " -" +
                              _vm._s(scope.row.supplier.id || "-") +
                              " 【" +
                              _vm._s(scope.row.supplier.mobile || "-") +
                              "】 "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplier_name",
              align: "center",
              label: "扣款时名称",
              "min-width": "200",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.supplier_name || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "logistic_business_name",
              align: "center",
              label: "集配中心",
              "min-width": "100",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.logistic_business_name || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "create_time",
              align: "center",
              label: "添加时间",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operate_name",
              align: "center",
              label: "添加人",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.operate_name || "-") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "deduction_amt",
              align: "center",
              label: "扣款金额",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "check_operate_name",
              align: "center",
              label: "审核人",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(scope.row.check_operate_name || "-") + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "deduction_type_txt",
              align: "center",
              label: "扣款类型",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "as_no",
              align: "center",
              label: "售后单号",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.as_no || "-") + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "order_no",
              align: "center",
              label: "订单号",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row?.order_no || "-") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              align: "center",
              label: "商品名称",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row?.title || "-") + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "trade_no",
              align: "center",
              label: "退款流水号",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row?.order_refund?.trade_no || "-") +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "deduction_state_txt",
              align: "center",
              label: "扣款状态",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "check_state_txt",
              align: "center",
              label: "审核状态",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "check_time",
              align: "center",
              label: "扣款时间",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.onHandleEdit(scope.row, "view")
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm.isAudit &&
                    scope.row.check_state === _vm.CHECK_STATUS.NO.value
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleEdit(scope.row, "audit")
                              },
                            },
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    _vm.isAudit &&
                    scope.row.check_state === _vm.CHECK_STATUS.NO.value
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleEdit(scope.row, "delete")
                              },
                            },
                          },
                          [_vm._v("作废")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "作废",
                visible: _vm.centerDialogVisible,
                width: "40%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c("div", [
                _vm._v(
                  "供应商：" +
                    _vm._s(_vm.infodata.supplier_name) +
                    "[" +
                    _vm._s(_vm.infodata.supplier.mobile) +
                    "]"
                ),
              ]),
              _c("div", [
                _vm._v("扣款类型：" + _vm._s(_vm.infodata.deduction_type_txt)),
              ]),
              _c("div", [
                _vm._v(
                  "扣款金额： " + _vm._s(_vm.infodata.deduction_amt) + "元"
                ),
              ]),
              _c("div", [_vm._v("备注：")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  maxlength: 200,
                  "show-word-limit": true,
                  placeholder: "请输入内容",
                },
                model: {
                  value: _vm.textarea,
                  callback: function ($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea",
                },
              }),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.ajaxPostSupplierDeductionDel },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }